import React from "react";
import { NavLink as NavLinkRRD, Link, useHistory, useLocation } from "react-router-dom";
import { logout } from "../../network/ApiAxios";




//import EtrangerCDIenFranceOffres from "views/candidat/etrangerCDIenFranceOffres";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import qs from 'query-string';

import { NavDropdown } from "react-bootstrap";
import useCustomTranslation from "components/Translation/useCustomTranslation";




function PersonalAccountSidebar() {
  var user;
  if (localStorage.getItem("user")) {
    user = JSON.parse(localStorage.getItem("user"));
  } else {
    user = { role: "none" };
  };


  const history = useHistory();
  const { t } = useCustomTranslation();

  const location = useLocation();
  const query = qs.parse(location.search);
  const type = query.type || '';


  const logOut = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (token) {
      const response = await logout(token);
      const { data } = response;
      if (data.success) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // props.history.push("/auth/login");
        //history.push("/home/homepage");
        window.location.href = 'https://topdevacademy.com';
      }
    }
  };




  return (
    <>
      <Navbar
        className="navbar-vertical fixed-left navbar-light "
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}

          <button
            className="navbar-toggler"
            type="button"
          // onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>


          {/* Brand */}

          <NavbarBrand
            className="pt-0"
            to="/personal/trainings/Course"
            tag={Link}
          >
            <img
              src={require("assets/img/brand/logo.png").default}
              alt={"..."}
              className="ml-5"
              style={{ maxHeight: "fit-content" }}
            />

          </NavbarBrand>


          <Nav
            // className=""
            className="" navbar
          // className='list-unstyled pb-3'
          // vertical
          // navbar
          // expand="lg"
          >

            {/* <NavItem>
              <NavLink
                tag={NavLinkRRD}
                // onClick={this.closeCollapse}
                // activeClassName="active"
                to="/personal/homepage" >

                Accueil
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                tag={NavLinkRRD}
                // onClick={this.closeCollapse}
                // activeClassName="active"
                to="/personal/parameters" >

                {t`Parameters`}
              </NavLink>
            </NavItem>
            <NavDropdown title={t`Trainings`} id="basic-nav-dropdown">
              <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to={`/personal/trainings/Course`}
                  className={type === 'course' ? 'active' : ''}
                >
                  <i className={"ni ni-briefcase-24"} />
                  {t`Course`}
                </NavLink>
              </NavItem>

              {/* <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to={`/personal/trainings/Stack`}
                >
                  <i className={"ni ni-briefcase-24"} />
                  {t`Stack`}
                </NavLink>
              </NavItem> */}

              <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to={`/personal/subscriptions`}
                >
                  <i className={"ni ni-briefcase-24"} />
                  {t`Subscriptions`}
                </NavLink>
              </NavItem>
            </NavDropdown>
            <NavItem>
              <NavLink
                tag="a"
                onClick={logOut}
                // onClick={this.closeCollapse}
                // activeClassName="active"
                href="#"
              >

                {t`LogOut`}
              </NavLink>
            </NavItem>


          </Nav>



        </Container>
      </Navbar>




    </>


  )

};


export default PersonalAccountSidebar;
